/**
 * @format
 * @Postat
 */

import { useContext, useEffect, useState } from 'react';

import { Link, useLocation } from 'react-router-dom';

import { EventContext } from '../../../Contexts/EventContext';
import ModalCustom from '../../../Shared/Components/ModalCustom';
import Pagination from '../../../Shared/Components/Pagination';
import { error, success } from '../../../Shared/Components/Toast';
import useApi from '../../../Shared/hooks/api/Index';
import { useAccess } from '../../../Shared/hooks/useAccess';
import Master from '../../Layouts/Master';

const Post = () => {
  const eventContext = useContext(EventContext);
  const { search } = useLocation();
  const [, setLoading] = useState(false);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [PostRemoveId, setPostRemoveId] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { canManageBaseData } = useAccess();
  useEffect(() => {
    getPost();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);
  const getPost = async () => {
    setLoading(true);
    await useApi.get(
      `/panel/base/post/${search}`,
      {},
      (res) => {
        eventContext.posts = res.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };
  const removePost = async (PostId) => {
    setRemoveLoading(true);

    await useApi.delete(
      `/panel/base/post/${PostId}`,
      {},
      (res) => {
        success('ساختار تیم مورد نظر با موفقیت حذف شد');
        setRemoveLoading(false);
        setModalIsOpen(false);
        getPost();
      },
      (err) => {
        setRemoveLoading(false);
        setLoading(false);
        error('حذف به علت خطا انجام نشد');
      },
    );
  };

  return (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            لیست ساختار تیم
          </h1>
        </div>
        {canManageBaseData() && (
          <Link
            to='/panel/base-define/post/create'
            className='d-flex flex-row btn btn-outline-info '
          >
            <i className='fad fa-plus f-16 mx-2'></i>
            <span className='f-13'>ایجاد ساختار تیم</span>
          </Link>
        )}
      </div>
      <div className='w-100 overflow-auto'>
        {eventContext.posts?.data?.length > 0 ? (
          <table className='table table-hover'>
            <thead>
              <tr>
                <th>#</th>
                <th>عنوان</th>
                <th>وضعیت</th>
                {canManageBaseData() && <th>عملیات</th>}
              </tr>
            </thead>
            <tbody>
              {eventContext.posts?.data?.map((item) => (
                <tr key={item.id}>
                  <th>{item.id}</th>
                  <td>{item.title}</td>
                  <td>
                    <span
                      className={`badge badge-${
                        item.status === 0 ? 'danger' : 'success'
                      } badge-pill p-2`}
                    >
                      {item.status === 0 ? 'غیرفعال' : 'فعال'}
                    </span>
                  </td>
                  {canManageBaseData() && (
                    <td>
                      <div className='d-flex flex-row'>
                        <Link
                          to={`/panel/base-define/post/edit/${item.id}`}
                          className='mx-2'
                        >
                          ویرایش
                        </Link>
                        {canManageBaseData() && (
                          <Link
                            className='mx-2'
                            to='#'
                            onClick={(e) => {
                              e.preventDefault();
                              setPostRemoveId(item.id);
                              setModalIsOpen(true);
                            }}
                          >
                            حذف
                          </Link>
                        )}
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border p-3 my-3	'>
            <i className='fad fa-plus f-16 mx-2 text-secondary'></i>
            <span className='f-13 font-weight-bold text-secondary'>
              برای ایجاد ساختار تیم بر روی منوی ایجاد ساختار تیم کلیک کنید
            </span>
          </div>
        )}
      </div>
      <div className='w-100 mt-4 d-flex'>
        <Pagination
          totalPage={eventContext.posts?.meta?.pagination?.total_pages}
          basePath='/panel/base-define/post'
        />
      </div>
      <ModalCustom modalIsOpen={modalIsOpen}>
        <div className='d-flex flex-row border-bottom pb-2'>
          <i className='fad fa-warning f-20 mx-2'></i>
          <span className=''>آیا از حذف ساختار تیم مطمئنید‌؟</span>
        </div>
        <div className='d-flex flex-row justify-content-around my-3'>
          <button
            onClick={() => setModalIsOpen(false)}
            className='btn btn-danger w-48 f-13'
          >
            لغو
          </button>
          <button
            onClick={() => removePost(PostRemoveId)}
            className='btn btn-success w-48 f-13'
          >
            {removeLoading ? (
              <div
                className='spinner-border spinner-border-sm text-white mb-1'
                role='status'
              ></div>
            ) : (
              'بله'
            )}
          </button>
        </div>
      </ModalCustom>
    </Master>
  );
};

export default Post;
